import { AppTableImproved } from "@/shared/Components";
import type { AppTablePropsImproved } from "@/shared/Components";
import type { NotesTableRowData } from "../../model/types/notes-table-types";
import type { FC } from "react";

type NotesTableV3Props = AppTablePropsImproved<NotesTableRowData>;

export const NotesTableV3: FC<NotesTableV3Props> = (props) => {
  return <AppTableImproved<NotesTableRowData> {...props} />;
};
